import { useSelector } from "react-redux";

// Use throughout your app instead of plain `useSelector`
const useAppSelector = useSelector;

export default useAppSelector;
